// Centralized route-aware SEO metadata and shared asset URLs.
// The real site origin comes from the VITE_SITE_URL environment variable,
// with a runtime fallback to the actual deployed origin.

export const SITE_NAME = "AllChinaBuy Spreadsheet";

export const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/49750b7389edabeda6497a215e0702e5.png";

export const SITE_OG_IMAGE =
  "https://readdy.ai/api/search-image?query=Soft%20pastel%20minimal%20flat%20lay%20of%20sneakers%20hoodies%20caps%20and%20shopping%20bags%20arranged%20on%20a%20clean%20light%20sage%20green%20background%2C%20airy%20European%20lifestyle%20aesthetic%2C%20soft%20natural%20daylight%2C%20editorial%20product%20photography%2C%20subtle%20shadows%2C%20harmonious%20composition&width=1600&height=700&seq=allchina-hero-2026&orientation=landscape";

export const ARTICLE_IMAGE =
  "https://readdy.ai/api/search-image?query=Clean%20organized%20spreadsheet%20concept%20with%20fashion%20products%20sneakers%20hoodies%20and%20caps%20floating%20around%20a%20minimal%20light%20background%2C%20soft%20sage%20green%20and%20cream%20tones%2C%20modern%20European%20editorial%20style%2C%20airy%20and%20bright%20composition&width=1200&height=600&seq=allchina-article-2026&orientation=landscape";

export const SITE_URL =
  import.meta.env.VITE_SITE_URL || window.location.origin;

export interface RouteSeo {
  title: string;
  description: string;
  keywords: string;
  image?: string;
  ogType?: string;
}

export const routeSeoMap: Record<string, RouteSeo> = {
  "/": {
    title: "AllChinaBuy Spreadsheet — Products, Sellers & Buying Guides",
    description:
      "Explore the AllChinaBuy spreadsheet resource hub. Find products, sellers, categories and buying guides across shoes, fashion, bags and streetwear — all organized in one place.",
    keywords:
      "AllChinaBuy spreadsheet, AllChinaBuy products, AllChinaBuy sellers, AllChinaBuy categories, AllChinaBuy buying guide",
    image: SITE_OG_IMAGE,
    ogType: "website",
  },
  "/products": {
    title:
      "AllChinaBuy Spreadsheet Products — Shop Shoes, Hoodies, Jackets & More",
    description:
      "Browse the full AllChinaBuy spreadsheet product catalog organized by category. Find shoes, hoodies, t-shirts, jackets, bags and more with direct links to buy on the main website.",
    keywords:
      "AllChinaBuy products, AllChinaBuy spreadsheet products, AllChinaBuy categories, AllChinaBuy shoes, AllChinaBuy hoodies",
    image: SITE_OG_IMAGE,
    ogType: "website",
  },
  "/spreadsheet-guide": {
    title: "AllChinaBuy Spreadsheet Guide — How to Use, Categories & Safety Tips",
    description:
      "A complete guide to the AllChinaBuy spreadsheet. Learn how to navigate categories, find sellers, review products, understand shipping and shop safely.",
    keywords:
      "AllChinaBuy spreadsheet guide, AllChinaBuy how to use, AllChinaBuy categories, AllChinaBuy safety, AllChinaBuy buying guide",
    image: ARTICLE_IMAGE,
    ogType: "article",
  },
};

export function resolveRouteSeo(pathname: string): RouteSeo | undefined {
  return routeSeoMap[pathname];
}